import { DataSampling } from 'features/workspace/types/dataSampling'

export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/prebid-stack/prebid-analytics'

export const DATA_SAMPLING_DEFAULT: DataSampling = '10'
